import { useEffect, useState } from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  makeStyles,
  Link,
} from "@material-ui/core";
import useCheckPermission from "../hooks/useCheckPermission";

const useStyles = makeStyles({
  allContainer: {
    minWidth: "100%",
    width: "100%",
    margin: "0 auto",
    paddingTop: 50,
    backgroundColor: "rgba(200,200,200,200)",
    backdropFilter: "blur(5px)",
  },
  title: {
    fontSize: 30,
    color: "#b00020",
  },
  paper: {
    margin: 0,
    minWidth: 667,
    width: 667,
    maxWidth: 667,
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    padding: 10,
    alignItems: "center",
    height: 150,
  },
  button: {
    height: 64,
    fontSize: 24,
    borderRadius: 0,
  },
  link: {
    width: "100%",
  },
  dialogAction: { padding: 0, boxSizing: "border-box" },
});
const PermissionChecker = ({ code, write }) => {
  const classes = useStyles();
  const [allow, setAllow] = useState();
  const [loading, setLoading] = useState(true);
  const { checkReadPermission, checkWritePermission } = useCheckPermission();
  useEffect(() => {
    async function setAlloworNot() {
      if (write) {
        const result = await checkWritePermission(code);
        setAllow(result);
        setLoading(false);
        return;
      } else {
        const result = await checkReadPermission(code);
        setAllow(result);
        setLoading(false);
        return;
      }
    }

    setAlloworNot();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading)
    return (
      <Dialog
        aria-labelledby="customized-dialog-title"
        open={true}
        className={classes.allContainer}
        onClose={null}
      >
        Loading
      </Dialog>
    );
  if (allow) return null;

  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      open={true}
      className={classes.allContainer}
      onClose={null}
    >
      <DialogTitle id="customized-dialog-title">
        <Typography align="center" classes={{ root: classes.title }}>
          Sorry
        </Typography>
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }}>
        You dont' have permission to view this page
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogAction }}>
        <Link href="/" className={classes.link}>
          <Button
            onClick={null}
            color="primary"
            fullWidth
            variant="contained"
            classes={{ contained: classes.button }}
          >
            Back to Home
          </Button>
        </Link>
      </DialogActions>
    </Dialog>
  );
};

export default PermissionChecker;
